export const OperatoryHeader = {
  flow: 'y',
  gap: 'Y',
  padding: 'A',
  align: 'center center',
  background: 'inkMid',
  borderBottom: '1px solid inkBorder',

  OperatoryName: {
    text: (el, s) => s.operatoryName || 'Chair 1',
    fontSize: 'Z',
    fontWeight: '700',
    color: 'inkText'
  },
  AssignedProvider: {
    text: (el, s) => s.assignedProvider || '',
    fontSize: 'Y',
    color: 'inkMuted'
  },
  UtilizationWrap: {
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    width: '100%',
    UtilizationBar: {
      flex: '1',
      height: 'X',
      round: 'X',
      background: 'inkBorder',
      overflow: 'hidden',
      Fill: {
        height: '100%',
        round: 'X',
        background: 'teal',
        width: (el, s) => {
          const pct = s.utilizationPercent || 0
          return `${pct}%`
        },
        transition: 'width 0.3s'
      }
    },
    UtilizationLabel: {
      text: (el, s) => s.utilizationPercent != null ? `${s.utilizationPercent}%` : '',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'teal',
      minWidth: 'B'
    }
  }
}
